import { isBooleanFalse, isBooleanTrue, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from '../utils/objectUtils';
import { create, getAll, getById, getByIdQuery, getBySingleQuery, remove, update, updateField } from '../utils/dbUtils';
import { collection, endBefore, getCountFromServer, getDocs, limit, limitToLast, orderBy, query, startAfter, where } from 'firebase/firestore';
import { db } from '../firebase';
import { asTimeZone } from '../utils/dateFormatter';
import moment from "moment-timezone";

class Condition {
	static collectionName = 'conditions';

	name = null;

	constructor(condition) {
		if (isObjectNotEmpty(condition)) {
			if (isStringNotEmpty(condition.name)) { this.name = condition.name; }
		}
	}

	toDto = () => {
		return {
			name: this.name,
		};
	}

	create = async () => {
		const newCondition = await create(Condition.collectionName, this.toDto());
		if (isObjectNotEmpty(newCondition)) {
			// create user conditions for users if new condition is created
			// await UserCondition.createForUsers(newCondition.conditionId);

			return newCondition;
		}

		return null;
	}

	static updateField = async (id, fieldName, newValue) => {
		return await updateField(Condition.collectionName, id, fieldName, newValue);
	}

	static update = async (id, updatedCondition) => {
		const updatedObj = new Condition(updatedCondition);
		return await update(Condition.collectionName, id, updatedObj.toDto());
	}

	static delete = async (id) => {
		return await remove(Condition.collectionName, id);
	}

	static getById = async (id) => {
		return await getById(Condition.collectionName, id);
	}

	static getAll = async () => {
		return await getAll(Condition.collectionName);
	}

	static getByField = async (fieldName, fieldValue, comparer) => {
		return await getBySingleQuery(Condition.collectionName, fieldName, fieldValue, comparer);
	}

	static getByIds = async (ids) => {
		return await getByIdQuery(Condition.collectionName, ids, 'in');
	}

	static getCount = async (queryParameters) => {
		const { start, end } = queryParameters;

		let queryConstraints = [];

		if (isNotNullOrUndefined(start)) {
			let startDate = asTimeZone(moment(new Date(start)), 'US/Pacific').startOf('day').utc().toDate();
			queryConstraints.push(where('createdAt', '>=', startDate));
		}

		if (isNotNullOrUndefined(end)) {
			let endDate = asTimeZone(moment(new Date(end)), 'US/Pacific').endOf('day').utc().toDate();
			queryConstraints.push(where('createdAt', '<=', endDate));
		}

		let q = query(collection(db, Condition.collectionName), ...queryConstraints);

		const snapShot = await getCountFromServer(q);

		//console.log(snapShot.data());

		return snapShot.data().count;
	}

	static getPaginated = async (queryParameters, pageSize = 25, firstVisible, lastVisible, orderByField = 'createdAt') => {
		const { hasTest, hasVaccination, start, end } = queryParameters;

		let queryConstraints = [];

		if (isNotNullOrUndefined(hasTest)) {
			if (isBooleanTrue(hasTest)) {
				queryConstraints.push(where('hasTest', '==', true));
			} else if (isBooleanFalse(hasTest)) {
				queryConstraints.push(where('hasTest', '==', false));
			}
		}

		if (isNotNullOrUndefined(hasVaccination)) {
			if (isBooleanTrue(hasVaccination)) {
				queryConstraints.push(where('hasVaccination', '==', true));
			} else if (isBooleanFalse(hasVaccination)) {
				queryConstraints.push(where('hasVaccination', '==', false));
			}
		}

		if (isNotNullOrUndefined(start)) {
			let startDate = asTimeZone(moment(new Date(start)), 'US/Pacific').startOf('day').utc().toDate();
			queryConstraints.push(where('createdAt', '>=', startDate));
		}

		if (isNotNullOrUndefined(end)) {
			let endDate = asTimeZone(moment(new Date(end)), 'US/Pacific').endOf('day').utc().toDate();
			queryConstraints.push(where('createdAt', '<=', endDate));
		}

		let q = null;
		if (isObjectNotEmpty(firstVisible)) {
			q = query(collection(db, Condition.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limitToLast(pageSize), endBefore(firstVisible[orderByField], firstVisible['id']));
		} else if (isObjectNotEmpty(lastVisible)) {
			q = query(collection(db, Condition.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize), startAfter(lastVisible[orderByField], lastVisible['id']));
		} else {
			q = query(collection(db, Condition.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize));
		}

		let snapshot = await getDocs(q);
		return snapshot.docs.map((doc) => {
			return {
				id: doc.id,
				...doc.data()
			};
		});
	}

	static get = async (queryParameters) => {
		let allRecords = [];
		try {
			let next = null;
			let totalPages = 0;

			let totalCount = await this.getCount(queryParameters);
			totalPages = Math.ceil(totalCount / 10000.0);
			// console.log('totalCount: ' + totalCount);
			// console.log('totalPages: ' + totalPages);
			let pages = [];
			for (let i = 0; i < totalPages; i++) {
				pages.push(i + 1);
			}
			for (const page of pages) {
				// console.log('starting page ' + page);

				let list = await this.getPaginated(queryParameters, 10000, null, next, 'createdAt');

				// console.log(list.length);
				allRecords = [...allRecords, ...list];

				// console.log(allRecords.length);

				// console.log('go to next page');
				next = list[list.length - 1];
			}
		} catch (error) {
			console.log(error);
		}

		return allRecords;
	}
}

export default Condition;